export default {"src":"/_next/static/media/warning.fa26908a.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};